import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Icons, IconsVariants } from '../../UI';

export const BottomNav: React.FC = () => {
  const location = useLocation();
  const userId = localStorage.getItem('userId');
  const userIsLogged = !!userId;

  return (
    <nav className="laptop:hidden fixed bottom-0 left-0 right-0 z-40 bg-app-card border-t border-gray-800">
      <div className="flex justify-around items-center h-14">
        <NavLink
          to="/"
          className={({ isActive }) =>
            `flex flex-col items-center justify-center flex-1 h-full ${isActive ? 'text-app-primary' : 'text-app-gray'}`
          }
        >
          <Icons variant={IconsVariants.HOME_FULL} classes="w-6 h-6" />
          <span className="text-[10px] mt-0.5">Home</span>
        </NavLink>

        <NavLink
          to="/soulmates"
          className={({ isActive }) =>
            `flex flex-col items-center justify-center flex-1 h-full ${isActive ? 'text-app-primary' : 'text-app-gray'}`
          }
        >
          <Icons variant={IconsVariants.GLASS} classes="w-6 h-6" />
          <span className="text-[10px] mt-0.5">Soulmates</span>
        </NavLink>

        {userIsLogged ? (
          <NavLink
            to="/create-pinion"
            state={{ backgroundLocation: location }}
            aria-label="Create pinion"
            className="flex items-center justify-center w-12 h-12 -mt-4 rounded-full bg-app-primary text-white shadow-lg"
          >
            {/* FA renders the glyph as an ::before inside an inline-block <i>;
                w-6/h-6 size the box but not the glyph, so it sat off-centre in
                the circle. inline-flex + centring + leading-none centres it.
                `!inline-flex` because FontAwesome's own `.fa-solid { display }`
                rule is imported after Tailwind (src/index.tsx) and would other-
                wise win the equal-specificity tie and keep it inline-block. */}
            <Icons variant={IconsVariants.PLUS_SQUARE} classes="w-6 h-6 !inline-flex items-center justify-center text-xl leading-none" />
          </NavLink>
        ) : (
          <NavLink
            to="/login"
            state={{ backgroundLocation: location }}
            aria-label="Log in"
            className="flex items-center justify-center w-12 h-12 -mt-4 rounded-full bg-app-primary text-white shadow-lg"
          >
            <Icons variant={IconsVariants.USER_FULL} classes="w-6 h-6 !inline-flex items-center justify-center text-xl leading-none" />
          </NavLink>
        )}

        {userIsLogged ? (
          <NavLink
            to="/bookmarks"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 h-full ${isActive ? 'text-app-primary' : 'text-app-gray'}`
            }
          >
            <Icons variant={IconsVariants.BOOKMARK} classes="w-6 h-6" />
            <span className="text-[10px] mt-0.5">Bookmarks</span>
          </NavLink>
        ) : (
          <NavLink
            to="/login"
            state={{ backgroundLocation: location }}
            className="flex flex-col items-center justify-center flex-1 h-full text-app-gray"
          >
            <Icons variant={IconsVariants.USER_FULL} classes="w-6 h-6" />
            <span className="text-[10px] mt-0.5">Login</span>
          </NavLink>
        )}

        {userIsLogged ? (
          <NavLink
            to={`/profile/${userId}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 h-full ${isActive ? 'text-app-primary' : 'text-app-gray'}`
            }
          >
            <Icons variant={IconsVariants.PROFILE_FULL} classes="w-6 h-6" />
            <span className="text-[10px] mt-0.5">Profile</span>
          </NavLink>
        ) : (
          <NavLink
            to="/register"
            state={{ backgroundLocation: location }}
            className="flex flex-col items-center justify-center flex-1 h-full text-app-gray"
          >
            <Icons variant={IconsVariants.ID_CARD} classes="w-6 h-6" />
            <span className="text-[10px] mt-0.5">Register</span>
          </NavLink>
        )}
      </div>
    </nav>
  );
};
